'use client';
import Dialog from '@ui/Dialog';
import Typography from '@ui/Typography';
import useConnectModalStore from '@/components/store/connectModalSlice';
import React, { useState } from 'react';
import ConnectModalForm from './ConnectModalForm';
import Image from 'next/image';
import { requestPost } from '@utils/httpService';
import { ScrollArea } from '../next-ui/ScrollArea';

function ConnectModal(props) {
  const isOpen = useConnectModalStore((state) => state.open);
  const company = useConnectModalStore((state) => state.company);
  const setIsOpen = useConnectModalStore((state) => state.setOpen);

  const [step, setStep] = useState('form');

  function closeModal() {
    setStep('form');
    setIsOpen(false);
  }

  async function onSubmit(data) {
    const res = await fetch(
      `${process.env.NEXT_PUBLIC_API_HOST}/v1/public/companies/${company.id}/connect`,
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(data),
      },
    );

    if (res.ok) {
      const { data } = await res.json();
      console.log('Connect to company', data);
      setStep('success');
    }
  }

  return (
    <Dialog
      isOpen={isOpen}
      onClose={closeModal}
      maxWidth="lg"
      iconUrl={company ? company.logoUrl : null}>
      <div className="flex w-full flex-1 gap-12">
        <div className="hidden shrink-0 grow-0 items-center lg:flex">
          <Image
            width={333}
            height={303}
            src="/assets/images/public-connect-modal-image.jpg"
            alt="background image"
            priority
          />
        </div>
        {step === 'form' && (
          <div className="flex grow flex-col overflow-hidden">
            <Typography variant="h1" component="h2" className="mb-8">
              Reach out to us!
            </Typography>
            <ScrollArea className="flex-1 lg:pr-4">
              <ConnectModalForm onSubmit={onSubmit} />
            </ScrollArea>
          </div>
        )}
        {step === 'success' && (
          <div className="flex flex-1 flex-col gap-8">
            <Typography variant="h1" component="h2">
              Thank You!
            </Typography>
            <Typography variant="body1">
              Your request has been submitted. Someone from the team will reach
              out to you shortly.
            </Typography>
          </div>
        )}
      </div>
    </Dialog>
  );
}

export default ConnectModal;
